function customTypeof(value) {
  if (Array.isArray(value)) {
    return "array";
  } else if (Number.isNaN(value)) {
    return "nan";
  } else {
    return typeof value;
  }
}

const addBranchNo = (input, branchNo) => {
  let type = customTypeof(input);
  let res = "";

  switch (type) {
    case "string":
      res = branchNo + input;
      break;
    case "number":
      res = branchNo + input.toString();
      break;
    default:
      res = "";
      break;
  }
  return res;
};

export default addBranchNo;
